__turbopack_context__.v({
  "content": "SlowTextSection-module__R-eGTq__content",
  "root": "SlowTextSection-module__R-eGTq__root",
});
